var consts = require('protocol/consts');

/**
 * Create a connection request with provided options
 */
function createConnectionRequest() {
    return {
        type : consts.TYPE,
        version : consts.CURRENT_VERSION,
        capabilities : consts.CAPABILITIES
    };
}

function createReconnectionRequest(token, availableClientSequence, lastServerSequence) {
    var req = createConnectionRequest();

    req.token = token;
    req.availableClientSequence = availableClientSequence;
    req.lastServerSequence = lastServerSequence;

    return req;
}

module.exports = {
    connect : createConnectionRequest,
    reconnect : createReconnectionRequest
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/protocol/connection-request.js
// module id = 1004
// module chunks = 1